import "./src/style/_variables.scss";
import "./src/style/style.scss";
import "./src/style/responsive.scss";

import { createRoot, hydrateRoot } from "react-dom/client";

export const disableCorePrefetching = () => true;

export const onRouteUpdate = ({ location }) => {
    if (!location.hash) {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
};

export const replaceHydrateFunction = () => {
  return (element, container) => {
    if (process.env.NODE_ENV === "development") {
      const root = createRoot(container);
      root.render(element);
    } else {
      hydrateRoot(container, element);
    }
  };
};
